module.exports = __webpack_public_path__ + "static/media/othersubjects.2f06b964.png";